import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { BrowserQRCodeReader } from "@zxing/library";
import axios from "axios";
import Footer from "../ComponentPrimer/Footer";

const SelfCheckIn = () => {
  const [scanResult, setScanResult] = useState("Invalid");
  const [name, setName] = useState("Invalid");
  const [modalOpen, setModalOpen] = useState(true);
  const [modalMessage, setModalMessage] = useState("");
  const [modalCek, setModalCek] = useState("");
  const [modalType, setModalType] = useState("success");
  const [isScanning, setIsScanning] = useState(true);
  const [countdown, setCountdown] = useState(5); 
  const [selectedDeviceId, setSelectedDeviceId] = useState(null); 
  const videoRef = useRef(null);

  // Mendapatkan daftar perangkat kamera
  useEffect(() => {
    const getDevices = async () => {
      try {
        const devices = await BrowserQRCodeReader.listVideoInputDevices();

        // Pilih kamera depan jika tersedia
        const frontCamera = devices.find((device) =>
          device.label.toLowerCase().includes("front")
        );

        setSelectedDeviceId(frontCamera?.deviceId || devices[0]?.deviceId);
      } catch (error) {
        console.error("Gagal mendapatkan perangkat kamera:", error);
      }
    };

    getDevices();
  }, []);

  // Memulai pemindaian QR Code
  useEffect(() => {
    const codeReader = new BrowserQRCodeReader();

    const startScanning = async () => {
      if (isScanning && selectedDeviceId) {
        try {
          await codeReader.decodeFromVideoDevice(
            selectedDeviceId,
            videoRef.current,
            (result, error) => {
              if (result) {
                setScanResult(result.getText());
                checkAndUpdateQRCode(result.getText());
                setIsScanning(false); 
              } else if (error) {
                console.error("Error:", error);
              }
            }
          );
        } catch (err) {
          console.error("Gagal memulai pemindaian:", err);
        }
      }
    };

    startScanning();

    return () => codeReader.reset();
  }, [isScanning, selectedDeviceId]);

  // Countdown otomatis
  useEffect(() => {
    if (modalOpen && countdown > 0) {
      const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(timer); 
    } else if (countdown === 0 && modalOpen) {
      toggleModal(); 
    }
  }, [modalOpen, countdown]);

  const checkAndUpdateQRCode = (qrData) => {
    if (qrData === "Invalid") return;

    axios
      .get(`https://app.rlagency.id/apiopenhouse/check-qrcode.php?qrcode=${qrData}`)
      .then((response) => {
        if (response.data.exists) {
          setName(response.data.name); 
          updateLog(response.data.phone); 
        } else {
          showFailureModal(); 
        }
      })
      .catch((error) => {
        console.error("Error checking QR Code:", error);
        showFailureModal(); 
      });
  };

  const updateLog = (phone) => {
    const currentTime = new Date();
    currentTime.setHours(currentTime.getHours() + 7);
    const formattedTime = currentTime.toISOString().slice(0, 19).replace("T", " ");

    axios
      .post("https://app.rlagency.id/apiopenhouse/update-log.php", {
        phone: phone,
        log: formattedTime,
      })
      .then((response) => {
        if (response.data.success) {
          setModalMessage("Log-In Berhasil!");
          setModalCek("Silahkan Masuk");
          setModalType("success");
          setModalOpen(true); 
        } else {
          showFailureModal(); 
        }
      })
      .catch((error) => {
        console.error("Error updating log:", error);
        showFailureModal(); 
      });
  };

  const showFailureModal = () => {
    setModalMessage("Log-In Gagal!");
    setModalCek("Gagal");
    setModalType("failure");
    setModalOpen(true); 
  };

  const toggleModal = () => {
    setModalOpen(false); 
    setIsScanning(true); 
    setCountdown(5); 
  };

  return (
    <div className="container">
      <div style={{ maxWidth: "700px", margin: "50px auto" }}>
        <h1 style={{ fontSize: "24px", textTransform: "uppercase", fontWeight: "600" }}>
          Self Check In Open House UPI YPTK
        </h1>

        <div>
          <video
            ref={videoRef}
            width="100%"
            height="auto"
            style={{ border: "1px solid black" }}
          />
        </div>

        <Modal isOpen={modalOpen} toggle={toggleModal} size="sm" centered>
          <ModalHeader toggle={toggleModal}>{modalMessage}</ModalHeader>
          <ModalBody>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  margin: "10px auto",
                  width: "100%",
                  maxWidth: "400px",
                  textAlign: "center",
                }}
              >
                <h2 
                    style={{
                        fontSize: '22px', 
                        marginBottom: '20px', 
                        backgroundColor: modalCek === 'Gagal Check-in' ? '#ef5350' : '#d1ffbd', 
                        borderRadius: '20px', 
                        padding: '5px 0px'
                    }}
                >
                    {modalCek}
                </h2>
                <div style={{padding:'20px', border:'solid 1px #ddd', borderRadius:'10px'}}>
                    <p style={{padding:'0px', margin:'0px'}}>
                    <strong>Nama Lengkap :</strong> <br />
                    {name}
                    </p>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-secondary" onClick={toggleModal}>
              Close ({countdown})
            </button>
          </ModalFooter>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default SelfCheckIn;
